module.exports = __webpack_public_path__ + "svg/logo_invoice.0d7a91d770f6225f0faa4fd7931e6818.svg";